import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";

import { HandPlatter, Building, CalendarClock, Eye } from "lucide-react";

import moment from 'moment/moment';

import ServiceFloor from 'services/serviceFloor';

import ComponentTimer from 'core/widgets/util/ComponentTimer';

const ComponentRoomGrid = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh() {
            loadData();
        }
    }));

    const [floors, setFloors] = useState([]);
    const [filterFloor, setFilterFloor] = useState([]);

    const [selFloor, setSelFloor] = useState('all');

    const floorService = new ServiceFloor();

    const sortTable = (filter) => {
        setSelFloor(filter);
        if (filter === 'all') {
            setFilterFloor(floors);
        } else {
            let tempList = floors.filter((item) => item.title === filter);
            setFilterFloor(tempList);
        }
    }

    const getColor = (sts) => {
        switch (sts) {
            case 'active':
                return 'bg-green-200';
            case 'inprog':
                return 'bg-red-200';
            case 'checkin':
                return 'bg-blue-200';
            case 'none':
            default:
                return 'bg-white';
        }
    }

    const loadData = () => {
        (async function () {
            var doc = await floorService.getAllFloor({}, '');
            setFloors(doc.data);
            setFilterFloor(doc.data);
            setSelFloor('all');
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className='w-full min-h-[86vh] px-2 py-2 bg-white rounded-md grid grid-cols-12 gap-1'>
            <div className='col-span-2 border-r p-1'>
                <ScrollArea className='h-[calc(86vh-16px)]'>
                    <ul>
                        <li className={`py-2 uppercase text-sm font-medium my-2 cursor-pointer rounded-md px-2 border border-dashed ${selFloor === 'all' ? 'text-prime border-prime bg-red-100' : 'hover:bg-gray-200'}`} onClick={() => {
                            sortTable('all');
                        }}>
                            All Floors
                        </li>
                        {
                            floors.length !== 0 && floors.map((cunit) => {
                                return <li className={`py-2 uppercase text-sm font-medium my-2 cursor-pointer rounded-md px-2 border border-dashed ${selFloor === cunit.title ? 'text-prime border-prime bg-red-100' : 'hover:bg-gray-200'}`} key={cunit._id}>
                                    <div className='flex items-center justify-between'>
                                        <span className='flex-grow' onClick={() => { sortTable(cunit.title); }}>{cunit.title}</span>
                                    </div>
                                </li>
                            })
                        }
                    </ul>
                </ScrollArea>
            </div>
            <div className="col-span-10 p-1">
                <ScrollArea className="h-[calc(86vh-16px)] overflow-hidden">
                    {
                        filterFloor.length !== 0 && filterFloor.map((cuint) => {
                            return <div className='w-full my-3 border border-gray-200 border-dashed p-1 rounded'>
                                <div className='w-full'>
                                    <div className='flex items-center justify-between'>
                                        <div className='flex items-center'>
                                            <Building size={22} />
                                            <h1 className='text-xl font-medium uppercase ml-1'>{cuint.title}</h1>
                                        </div>
                                    </div>
                                    <div className='my-2 h-[1px] bg-gray-300'></div>
                                </div>
                                <div className='w-full grid grid-cols-4 gap-2'>
                                    {
                                        cuint.units.length === 0 && < div className='h-[114px] p-2 rounded shadow col-span-6 border border-dashed border-prime cursor-pointer hover:shadow-md flex items-center justify-center'>
                                            <h1 className='text-sm font-medium text-prime'>No data found.</h1>
                                        </div>
                                    }
                                    {
                                        cuint.units.length !== 0 && cuint.units.map((unit, index) => {
                                            if (unit.type === 'Room') {
                                                return < div className={`h-[114px] p-2 rounded shadow col-span-1 border border-dashed border-gray-400 cursor-pointer hover:shadow-md ${getColor(unit.status)}`} key={index} onClick={() => {
                                                    //Todo: open booking view for room
                                                }}>
                                                    <div className='flex justify-between items-center px-1'>
                                                        <div>
                                                            <p className='text-xl font-medium font-serif'>{unit.title}</p>
                                                            <div className='flex items-center'>
                                                                <CalendarClock size={18} />
                                                                <ComponentTimer startTime={moment(unit.endTime).add(12, 'hours').toISOString()} isOn={unit.status !== 'none'} isElapsed={true} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='bg-gray-200 h-[1px] my-2'></div>
                                                    <div className='flex items-center justify-between'>
                                                        <div className='text-gray-600 flex items-center'>
                                                            <HandPlatter size={20} />
                                                            <p className='text-base font-medium font-serif ml-1'>₹ {unit.pending.toFixed(2)}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        })
                                    }
                                </div>
                            </div>
                        })
                    }
                </ScrollArea>
            </div>
        </div>
    )
});

export default ComponentRoomGrid;
